import React from 'react';
import { tUi } from '../utils/uiText';

export default function CitationsPanel({
  citations,
  groundingCount = 0,
  filesInContext = 0,
  showUnverifiedWarning = false,
  uiLanguage = 'en',
}) {
  const kbCount = groundingCount || (citations && citations.length) || 0;
  const uploadCount = filesInContext > 0 ? filesInContext : 0;
  const isGrounded = kbCount > 0 || uploadCount > 0;

  if (!isGrounded) {
    if (!showUnverifiedWarning) return null;
    return (
      <div className="mt-3 bg-gray-800/80 border border-amber-500/25 rounded-lg p-3">
        <p className="text-xs text-amber-300/90">
          {tUi(uiLanguage, 'citationsUnverifiedClaim')}
        </p>
      </div>
    );
  }

  const count = kbCount || uploadCount;
  const internalLabel = uploadCount > 0 && kbCount === 0
    ? tUi(uiLanguage, 'citationsUploadedDocuments')
    : (citations?.[0]?.label ||
      citations?.[0]?.source ||
      tUi(uiLanguage, 'citationsProprietaryCorpus'));

  const sourceLabel = count === 1 ? 'source' : 'sources';

  return (
    <div className="mt-3 bg-gray-800/80 border border-teal-500/20 rounded-lg p-3">
      <div className="flex flex-wrap items-center gap-2 mb-1">
        <span className="text-xs uppercase tracking-wide text-teal-400">
          {tUi(uiLanguage, 'citationsGroundedAssessment')}
        </span>
        <span className="rounded-full bg-teal-950/80 border border-teal-500/40 px-2 py-0.5 text-xs text-teal-200">
          {tUi(uiLanguage, 'citationsInternalSources', {
            count,
            sourceLabel,
          })}
        </span>
      </div>
      <p className="text-sm text-gray-400">
        {tUi(uiLanguage, 'citationsResponseInformedBy', { internalLabel })}
      </p>
    </div>
  );
}
